<div class="index_page_outer">
  <app-breadcrumb-list
    [partsOfUrl]="partsOfUrl()"
    [dark_backdrop]="true"
    [transparent]="true"
    [standard_max_width]="true"
  />
  <div class="index_content">
    <h1>
      {{ 'PAGES.MINI_SERVICES_INDEX.H1_PREFIX' | translate }}
      {{ activeCategoryTitle() }}
    </h1>

    @if (!loading() && index()?.parentCategory) {
      <p class="index_parent_link">
        <a [routerLink]="mainIndexPath()"
          >{{ 'PAGES.MINI_SERVICES_INDEX.ALL_IN_MAIN' | translate }}
          {{ mainCategoryTitle() }}</a
        >
      </p>
    }

    <div class="list-group">
      @if (loading()) {
        <div class="isLoading">
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
      } @else {
        @if (subCategories().length) {
          <h2>
            {{ 'PAGES.MINI_SERVICES_INDEX.SUB_CATEGORIES_TITLE' | translate }}
          </h2>
          @for (subCategory of subCategories(); track subCategory.asCat) {
            <div class="list-group-item">
              <div class="list-group-item-inner">
                <h5 class="mb-1">
                  <a [routerLink]="subCategory.indexPath"
                    >{{ subCategory.title || subCategory.slug }} ({{
                      subCategory.count
                    }})</a
                  >
                </h5>
              </div>
            </div>
          }
          @if (miniVerticals().length) {
            <h2>
              {{
                'PAGES.MINI_SERVICES_INDEX.DIRECT_SERVICES_TITLE' | translate
              }}
            </h2>
          }
        }
        @for (miniVertical of miniVerticals(); track miniVertical.slug) {
          <div class="list-group-item">
            <div class="list-group-item-inner">
              <h5 class="mb-1">
                <a [routerLink]="generateMiniVerticalLink(miniVertical)">{{
                  miniVertical.tT || miniVertical.h1
                }}</a>
              </h5>
            </div>
          </div>
        }
      }
    </div>
    <app-lp-footer />
  </div>
</div>
